import { createAction, props } from "@ngrx/store";
import { HEADER } from "./header.constants";

export const updateHeaderTitle = createAction(HEADER.UPDATE_HEADER, props<{ title: string }>());
